module.exports = __webpack_public_path__ + "img/pic@2x (3).3a95a200.png";